// Edition form for coach card

import * as Yup from 'yup';
import CardEditTemplate from './CardEditTemplate';
import GuidedTour from './GuidedTour';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isEmail from 'validator/lib/isEmail';
import Input from './Input';
import ContactsFields from './ContactsFields';
import { userUpdate } from '../utils/firebase';
import { useFirebase } from './FirebaseContextProvider';
import { wrapProfileUpdate } from '../utils/misc';
import placeholderPerson from '../assets/images/placeholder-person.png';

const steps = [
  {
    target: '.coach-card-edit',
    title: 'Personal information',
    content: 'Fill in your personal information first to access the app',
  },
];

export default function CoachCardEdit({ coach }) {
  const { userIsCoach, user } = useFirebase();
  const {
    id,
    name,
    phone,
    email,
    emailConsent,
    smsConsent,
  } = coach;

  const isOwnProfile = user?.id === id;

  const initialValues = {
    name: name || '',
    phone: phone || '',
    email: email || '',
    emailConsent: name ? emailConsent : true,
    smsConsent: name ? smsConsent : true,
  };

  const validationSchema = new Yup.ObjectSchema({
    name: Yup.string().max(100, 'Too long').required('Required'),
    phone: Yup.string()
      .required('Required')
      .test('is-valid-phone', 'Invalid', (value) =>
        value ? isMobilePhone(value, 'en-US', { strictMode: false }) : false,
      ),
    email: Yup.string()
      .test('is-valid-email', 'Invalid', (value) => isEmail(value))
      .required('Required'),
  });

  return (
    <GuidedTour steps={userIsCoach ? steps : []} tourKey='coach-card-edit-v1'>
      <CardEditTemplate
        className='coach-card-edit'
        showUploadWarning
        id={id}
        imgPath={coach.imgPath}
        imgThumbPath={coach.imgThumbPath}
        hasImage={!!coach.imgPath}
        placeholder={placeholderPerson}
        formConfig={{
          initialValues,
          validationSchema,
        }}
        update={wrapProfileUpdate(userUpdate, isOwnProfile)}
        create={() => {}}
        afterCreateNavPath={`/coaches/${id}#teams`}
        requireImage
      >
        {(formik) => (
          <>
            <Input
              name='name'
              placeholder='Name'
              {...formik.getFieldProps('name')}
              error={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : null
              }
            />
            <ContactsFields
              formik={formik}
              emailDisabled
              consentDisabled={!isOwnProfile}
            />
          </>
        )}
      </CardEditTemplate>
    </GuidedTour>
  );
}
